export function getSubdomains(hostname: string): string {
  return hostname.split('.').slice(0, -2).join('.');
}
